import React, { useState, useRef } from 'react';

import Dim from 'web/components/common/modal/common/Dim';
import Video from 'web/components/common/Video';

import classNames from 'classnames/bind';
import styles from './TeacherInterview.scss';
const cx = classNames.bind(styles);

const TeacherInterview = React.memo(
  ({
    handleOneToOne,
    handlePopup,
    isController = false,
    data = {},
    getMediaKeyRequest,
  }) => {
    const [playing] = useState(false);
    const videoEl = useRef(null);

    console.log({ file: data.file });
    const fileSplit = data.file.split('.');
    const extention = fileSplit ? fileSplit[fileSplit.length - 1] : null;

    console.log({ extention });

    // useEffect(() => {
    //   const fileSplit = data.file.split('.');
    //   const extention = fileSplit ? fileSplit[fileSplit.length - 1] : null;

    //   if (extention === 'm3u8') getMediaKeyRequest(data.file);
    // }, []);

    return (
      <Dim onClick={handlePopup.close}>
        <div
          className={cx('TeacherInterview', window.isMobile ? 'mobile' : '')}
          onClick={e => e.stopPropagation()}
        >
          {extention === 'm3u8' ? (
            <Video media={data.file} />
          ) : (
            <video
              className={`playing-${playing} ${
                data.className ? data.className : ''
              }`}
              ref={videoEl}
              width="250"
              src={data.file}
              autoPlay={true}
              controls
              controlsList="nodownload"
              disablePictureInPicture="true"
              loop
            />
          )}

          <span className={`close-btn-ico`} onClick={handlePopup.close}></span>
        </div>
      </Dim>
    );
  },
);

export default TeacherInterview;
